// http://kazupon.github.io/vue-i18n/en/messages.html
export default {
  '{0} Amount': '{0} Bedrag',
  '{0} couldn\'t be loaded': '{0} kon niet geladen worden',
  '{0} Product(s)': '{0} Product(en)',
  '{0} has been loaded.': '{0} is geladen.',
  '{0} have been saved': '{0} zijn opgeslagen',
  '{attribute} can\'t be empty.': '{attribute} mag niet leeg gelaten worden.',
  '{attribute} can\'t contain more than {max} characters.': '{attribute} mag niet meer dan {max} karakters bevatten',
  '{attribute} can\'t contain less than {min} characters.': '{attribute} mag niet minder dan {min} karakters bevatten',
  '{attribute} should be a valid e-mail address.': '{attribute} moet een geldig e-mailadres zijn.',
  '{attribute} should only contain numeric values.': '{attribute} mag enkel cijfers bevatten.',
  '{attribute} should be higher than {min}.': '{attribute} moet hoger zijn dan {min}.',
  '{attribute} should be less than {max}.': '{attribute} moet lager zijn dan {max}.',
  '{0} Payments': '{0} Betalingen',
  'Add {0}': '{0} toevoegen',
  'Add to {0}': 'Aan {0} toevoegen',
  'Addition': 'Toeslag',
  'Additional {0}': 'Bijkomende {0}',
  'Add New': 'Nieuwe toevoegen',
  'Add or remove cash by clicking on the button right below.': 'Cash toevoegen/verwijderen kan je doen door op de knop rechtsonder te klikken.',
  'Add products to the inventory count by scanning or searching them in the box below.': 'Voeg producten aan de stocktelling toe door ze te scannen of op te zoeken in de onderstaande zoekbalk',
  'Add received goods to the inventory stock.': 'Voeg ontvangen goederen toe aan de stockinventaris.',
  'Address': 'Adres',
  'Amount': 'Bedrag',
  'All': 'Alle',
  'All Items': 'Alle Items',
  'All products will be imported': 'Alle producten zullen worden geïmporteerd',
  'Alternatives': 'Alternatieven',
  'A new version of the software is available.': 'Een nieuwe versie van de software is beschikbaar.',
  'And': 'En',
  'Apply {0}': 'Pas {0} toe',
  'Are you sure?': 'Ben je zeker?',
  'Articles': 'Artikelen',
  'Artnr.': 'Artnr.',
  'Apartment, suite, unit, etc.': 'Bus',
  'Are you sure you want to continue?': 'Ben je zeker dat je wilt doorgaan?',
  'At the start of each business day, you must open your register and add the starting balance.': 'Aan het begin van iedere werkdag dient de kassa opgestart en een startbalans ingevuld te worden.',
  'Back': 'Terug',
  'Barcode': 'Barcode',
  'Before continuing, you need to configure the cash register.': 'Vooraleer verder te gaan dient de kassa eerst geconfigureerd te worden.',
  'Bestsellers': 'Bestsellers',
  'Bills': 'Briefjes',
  'Born before: {0}': 'Geboren voor: {0}',
  'Brand': 'Merk',
  'Cancel': 'Annuleren',
  'Canceled': 'Geannuleerd',
  'Card': 'Kaart',
  'Cart': 'Winkelwagen',
  'Cash': 'Contant',
  'Cash Flow': 'Cash Flow',
  'Cash-In': 'Cash-In',
  'Cash-Out': 'Cash-Out',
  'Cash Management': 'Cash Management',
  'Cash Movements': 'Kassa Transacties',
  'Cash Payments Received': 'Ontvangen Cash Betalingen',
  'Cash Register': 'Kassa',
  'Cash Register is closed': 'Kassa is gesloten',
  'Cash Register Code': 'Kassacode',
  'Catalog': 'Catalogus',
  'Change receipt language': 'Wijzig taal van order',
  'Check Code': 'Controleer Code',
  'Checking the network cable or router': 'Controleer de netwerkkabels, modem en router',
  'Checkout': 'Afrekenen',
  'Choose a {0}': 'Kies een {0}',
  'Choose an {0}': 'Kies een {0}',
  'City': 'Gemeente',
  'Clear': 'Leegmaken',
  'Clear Cart': 'Winkelmandje Leegmaken',
  'Close': 'Sluiten',
  'Close {0}': '{0} Sluiten',
  'Close Register': 'Kassa Sluiten',
  'Closed': 'Gesloten',
  'Closure #': 'Kassa-afsluiting #',
  'Coins': 'Munten',
  'Complete': 'Afronden',
  'Complete {0}': '{0} Afronden',
  'Completed': 'Afgerond',
  'Configure this cash register below.': 'Configureer de kassa hieronder.',
  'Contact an administrator.': 'Contacteer een administrator.',
  'Contact Information': 'Contactinformatie',
  'Contains at least 1 flavor': 'Bevat minstens 1 van deze smaken',
  'Contains all these flavors': 'Bevat al deze smaken',
  'Continue': 'Verdergaan',
  'Count': 'Telling',
  'Counted': 'Getelde',
  'Counted Number': 'Aantal',
  'Country': 'Land',
  'Country code': 'Landcode',
  'Current Stock': 'Huidige Stock',
  'Customer': 'Klant',
  'Customers': 'Klanten',
  'Customer Discount': 'Klantenkorting',
  'Date': 'Datum',
  'Date Of Birth': 'Geboortedatum',
  'Delete': 'Verwijderen',
  'Delete {0}': '{0} Verwijderen',
  'Description': 'Beschrijving',
  'Detailed cash count': 'Gedetailleerde cashtelling',
  'Details': 'Details',
  'Difference': 'Verschil',
  'Discount': 'Korting',
  'Does this product contain a tax stamp?': 'Bevat dit product een taxzegel?',
  'Dutch': 'Nederlands',
  'Edit': 'Bewerken',
  'Edit {0}': '{0} Bewerken',
  'English': 'Engels',
  'Email': 'E-mail',
  'Email Address': 'E-mailadres',
  'Employee': 'Werknemer',
  'Enter a {0}': 'Geef een {0} op',
  'Enter an amount': 'Geef een bedrag op',
  'Example': 'Voorbeeld',
  'Exclude products that are out of stock': 'Sluit producten die niet op stock zijn uit',
  'Expected': 'Verwacht',
  'Filter': 'Filter',
  'Finish': 'Afronden',
  'First Name': 'Voornaam',
  'Fixed Amount': 'Vast Bedrag',
  'Flavor': 'Smaak',
  'Flavors': 'Smaken',
  'Flavor Profile': 'Smaakcategorie',
  'Free Samples': 'Gratis Stalen',
  'French': 'Frans',
  'Full': 'Volledig',
  'Full {0}': 'Volledige {0}',
  'Full Screen': 'Volledig Venster',
  'General': 'Algemeen',
  'Gift Card': 'Cadeaubon',
  'Give A Discount': 'Geef Een Korting',
  'Give {0}': 'Geef {0}',
  'Guest': 'Gast',
  'Go Back': 'Ga Terug',
  'Go to {0}': 'Ga naar {0}',
  'How many items should be given as sample?': 'Hoeveel items worden meegegeven als gratis staal?',
  'Import {0}': 'Importeer {0}',
  'Import a set of products (f.e. all products of a specific brand) by scanning the QR code on a created inventory list.': 'Importeer een verzameling producten (bv. alle producten van een specifiek merk) door de QR code op een eerder aangemaakte inventarislijst te scannen.',
  'Import the products of an incoming order by scanning its QR code.': 'Importeer de producten van een binnenkomend order door diens QR code te scannen.',
  'Include all products in this inventory count.': 'Voeg alle producten toe aan deze stocktelling.',
  'Incoming Order': 'Binnenkomend Order',
  'Installation': 'Installatie',
  'Installation Date': 'Installatiedatum',
  'Inventory Count': 'Stocktelling',
  'Inventory Counts': 'Stocktellingen',
  'Inventory List': 'Inventarislijst',
  'Inventory Lists': 'Inventarislijsten',
  'Items that you count will appear here one-by-one to help you keep track.': 'Getelde items worden hier onder elkaar opgelijst om deze goed te kunnen opvolgen.',
  'It looks like this cash register has already been opened.': 'Het lijkt erop dat deze kassa reeds geopend is.',
  'Language': 'Taal',
  'Last Name': 'Achternaam',
  'Last register closure summary': 'Samenvatting van de vorige kassa-afsluiting',
  'Less': 'Minder',
  'Load {0}': '{0} Laden',
  'Login': 'Inloggen',
  'Logout': 'Uitloggen',
  'Max. Characters: {0}': 'Max. Aantal Karakters: {0}',
  'Minute': 'Minuut',
  'Minutes': 'Minuten',
  'More': 'Meer',
  'Multiple products found for barcode: "{0}".': 'Meerdere producten gevonden voor barcode: "{0}".',
  'Name': 'Naam',
  'Next': 'Volgende',
  'No results found.': 'Geen resultaten gevonden.',
  'Number of {0}': 'Aantal {0}',
  'No': 'Neen',
  'No {0}': 'Geen {0}',
  'None': 'Geen',
  'Normal Screen': 'Normaal Venster',
  'Note': 'Nota',
  'Not yet counted': 'Nog niet geteld',
  'Nr': 'Nr',
  'Unique Code': 'Unieke Code',
  'Once you complete your register closure, all of the day\'s cash (including any cash movements and float) should be counted. If you decide to remove some redundant cash from the drawer you should enter this at "Safedrop".': 'Wanneer je je kassa-afsluiting wilt afronden, dient alle cash (alle kassatransacties en startbalans) geteld te worden. Als je besluit overbodige cash uit de kassalade te verwijderen, dien je dit bedrag in te vullen onder "Safedrop".',
  'Only products that have been counted in the past will be imported': 'Enkel eerder getelde producten zullen worden geïmporteerd',
  'Open': 'Openen',
  'Open {0}': '{0} Openen',
  'Open Drawer': 'Open Kassalade',
  'Open Cash Register': 'Open Kassasysteem',
  'Open/Close': 'Openen/Sluiten',
  'Opened': 'Geopend',
  'Opened At': 'Geopend Op',
  'Opening Float': 'Startbalans',
  'Opt-In to Marketing and Promotional Emails': 'Aanmelden Voor Marketing & Promotie Mailings',
  'Opt-In to Informative Emails': 'Aanmelden Voor Informatieve E-mails',
  'Order': 'Order',
  'Order Nr.': 'Order Nr.',
  'Orders': 'Orders',
  'Other': 'Andere',
  'Outgoing Order': 'Buitengaand Order',
  'Outstanding Balance': 'Openstaand Saldo',
  'Park Receipt': 'Order Parkeren',
  'Parked Receipts': 'Geparkeerde Bonnen',
  'Parked Sales': 'Geparkeerde verkopen',
  'Partial': 'Gedeeltelijk',
  'Partial {0}': 'Gedeeltelijke {0}',
  'Pay': 'Betalen',
  'Payment Method': 'Betaalmethode',
  'Payment Type': 'Betaaltype',
  'Payments': 'Betalingen',
  'Pc.': 'Stuks',
  'Pending': 'In wacht',
  'Percent': 'Percent',
  'Percentage': 'Percentage',
  'Phone': 'Telefoonnummer',
  'PIN Code': 'PIN Code',
  'Postal Code': 'Postcode',
  'Previous Count': 'Vorige Telling',
  'Price': 'Prijs',
  'Print': 'Afdrukken',
  'Printer': 'Printer',
  'Printerlist': 'Printerlijst',
  'Processed by {0}': 'Verwerkt door {0}',
  'Product': 'Product',
  'Products': 'Producten',
  'Quantity': 'Aantal',
  'Quantity of {0}': 'Aantal van {0}',
  'QZ Tray is not installed yet!': 'QZ Tray is nog niet geinstalleerd!',
  'Receipt': 'Bon',
  'Receipts': 'Bonnen',
  'Receipt will be automatically completed': 'Bon zal automatisch afgerond worden',
  'Receipt Discount': 'Kassakorting',
  'Recommendations': 'Aanraders',
  'Reconnecting to Wi-Fi': 'Maak opnieuw verbinding met wifi',
  'Refund': 'Teruggave',
  'Register': 'Kassa',
  'Reload': 'Herladen',
  'Return an item': 'Een item retourneren',
  'Register Closure': 'Kassa-afsluiting',
  'Register Closures': 'Kassa-afsluitingen',
  'Register closures are a basic part of retail that allow you to physically check your cash and credit totals against their recorded totals.': 'Kassa-afsluitingen zijn wettelijk verplicht en maken het mogelijk om de inhoud van de kassa af te toetsen met de geregistreerde cash hoeveelheden.',
  'Replace': 'Vervangen',
  'Reload {0}': '{0} herladen',
  'Remove {0}': '{0} verwijderen',
  'Resetting the modem or router': 'Herstart de modem of router',
  'Results': 'Resultaten',
  'Rounded': 'Afgerond',
  'Row Discount': 'Rijkorting',
  'Safedrop': 'Safedrop',
  'Sales': 'Verkopen',
  'Sales History': 'Verkoopshistoriek',
  'Save': 'Opslaan',
  'Schedule a full or partial inventory count to maintain accurate inventory levels.': 'Plan een volledige of gedeeltelijke stocktelling om je stockniveau\'s in orde te houden.',
  'Search': 'Zoeken',
  'Search a {0}': 'Zoek een {0}',
  'Search {0}': '{0} Zoeken',

  'Seconds': 'Seconden',
  'Select All': 'Selecteer Alle',
  'Select a {0}': 'Kies een {0}',
  'Select {0}': 'Kies {0}',
  'Select the correct product below.': 'Selecteer het juiste product hieronder',
  'Send {0}': 'Verzend {0}',
  'Set {0} items to {1}': 'Zet {0} items op {1}',
  'Set an opening float to open the register and make a sale.': 'Stel een startbalans in om de kassa op te starten en te beginnen verkopen.',
  'Settings': 'Instellingen',
  'Show {0}': 'Toon {0}',
  'Since': 'Sinds',
  'SKU': 'SKU',
  'Specify the products to include in this inventory count yourself.': 'Specifieer zelf de producten van deze stocktelling.',
  'Staff Discount': 'Personeelskorting',
  'Staff Note': 'Notitie',
  'Store': 'Winkel',
  'Store Catalog': 'Winkelcatalogus',
  'Subtotal': 'Subtotaal',
  'Summary': 'Overzicht',
  'Tax Stamp': 'Taxzegel',
  'Thank you for your purchase at {0}!': 'Bedankt voor uw aankoop bij {0}!',
  'The Cart Is Empty.': 'Het Winkelmandje Is Leeg.',
  'The counted amount doesn\'t match the expected amount.': 'Het getelde bedrag komt niet overeen met het verwachte bedrag.',
  'The difference is {0}.': 'Het verschil bedraagt {0}.',
  'The item(s) will be re-added to the stock': 'Item(s) worden opnieuw in stock geplaatst',
  'The item(s) won\'t be re-added to the stock': 'Item(s) worden niet opnieuw in stock geplaatst',
  'The order has been fully paid for': 'Het order is volledig betaald',
  'The order has been completed': 'Het order is afgerond',
  'There is no internet connection': 'Geen internet gevonden',
  'This cash register has already been installed.': 'Deze kassa is reeds geïnstalleerd.',
  'This cash register has already been open for more than a day.': 'Deze kassa is reeds langer dan een volledige dag geopend.',
  'This cash register needs to be initialized first. Please fill in the unique code in the form below and follow further instructions.': 'Deze kassa moet eerst geinitialiseerd worden. Vul de unieke code van deze kassa hieronder in en volg de verdere instructies.',
  'This computer hasn\'t been configured as a cash register yet.': 'Deze computer is nog niet geregistreerd als een kassa.',
  'This e-mail address is already in our database.': 'Dit e-mailadres zit reeds in onze database.',
  'This is correct': 'Dit is correct',
  'This is not a valid QR Code': 'Dit is geen geldige QR Code',
  'This note will be visible on the printed receipt.': 'Deze nota zal mee afgedrukt worden op de bon.',
  'This allows you to track any additional money you put into your cash drawer. This is used to increase your float amount during the day if required.': 'Hiermee kan je bijhouden hoeveel extra cash er aan de kassa is toegevoegd. Dit kan je gebruiken om tijdens de dag de balans van de kassa te verhogen indien nodig.',
  'Throughout the day you may want to add or remove cash from the cash drawer.': 'Gedurende de dag is het mogelijk dat je cash zou willen toevoegen/verwijderen uit de kassa.',
  'Time': 'Tijd',
  'To refund': 'Terug te betalen',
  'Total {0}': 'Totale {0}',
  'Total': 'Totaal',
  'Totals': 'Totalen',
  'Try': 'Probeer dit eens',
  'Uncounted': 'Ongetelde',
  'Unique nr.': 'Uniek nr.',
  'Unit price': 'Prijs per stuk',
  'Use The Google API For Address Lookup': 'Gebruik De Google Places API',
  'View All': 'Bekijk Alle',
  'VAT': 'BTW',
  'Verify if the information below is correct.': 'Verifieer of onderstaande informatie klopt.',
  'Warning': 'Opgelet',
  'Walk In': 'Gast',
  'We recommend to close the cash register before registering the next sale.': 'We raden aan om de kassa eerst af te sluiten vooraleer een nieuwe verkoop te starten.',
  'Welcome {0}': 'Welkom {0}',
  'When': 'Wanneer',
  'Where': 'Waar',
  'Why should the drawer be opened?': 'Waarom moet de kassalade geopend worden?',
  'Yes': 'Ja',
  'You can find more information about it below.': 'Je kan hieronder meer informatie terugvinden.',
  'Your computer is offline': 'Je computer is offline',
  'Your last counted items': 'Je laatst getelde items',
  'You Have Already Applied A Receipt Discount.': 'Je hebt reeds een kassakorting toegepast.',
  'You can use this option to track any cash you remove from your cash drawer. Cash out can be used to track actions such as safe drops, where you may need to remove cash from your drawer during the day for safekeeping.': 'Deze optie kan je gebruiken om bij te houden hoeveel cash er tussentijds uit de kassa gehaald is. Cash-outs kunnen bijvoorbeeld gebruikt worden om vanwege veiligheidsredenen een bepaalde hoeveelheid cash uit de kassa te halen.',
  'You didn\'t select a printer.': 'Je hebt geen printer geselecteerd.',
  'You need to type something here!': 'Je moet hier iets typen!',
  'You were helped by {0}': 'U bent geholpen door {0}'
}



// WEBPACK FOOTER //
// ./src/i18n/nl/index.js